<template>
  <div>
    <div class="lke-bg">
      <div class="lke-l">
        <v-top-title :title="'公告列表'" link="/jxggList" />
        <ul class="lke-ti-ul" v-loading="listLoading">
          <li type="none" v-for="(list, index) in noticeList" :key="index">
            <router-link
              :to="'/jxgg/' + list._id"
              style="text-decoration: none"
            >
              <p>{{ list.title }}</p>
            </router-link>
            <span class="lke-ti-ul-span">{{ list.releaseTime | addtime }}</span>
          </li>
          <li type="none" v-if="noticeList.length === 0">
            <p></p>
            <span class="lke-ti-ul-span">暂无公告</span>
          </li>
        </ul>
        <div v-if="roles !== 'notEnrolled'">
          <v-top-title :title="'课程列表'" link="/wdkc" />
          <ul class="lke-ti-ul" v-loading="listLoading">
            <li type="none" v-for="(list, index) in courseList" :key="index">
              <p>{{ list.name }}</p>
              <a
                target="_blank"
                style="text-decoration: none"
                :href="'/learnspace.html#?courseid=' + list._id"
              >
                <div class="lke-ti-ul-div">开始学习</div>
              </a>
            </li>
            <li type="none" v-if="courseList.length === 0">
              <p></p>
              <span class="lke-ti-ul-span">暂无课程</span>
            </li>
          </ul>
        </div>
        <!-- <div v-if="roles !== 'notEnrolled'">
          <dtjl />
        </div> -->
      </div>
      <div
        class="lke-r"
        v-if="roles === 'headquarters' || roles === 'nonHeadquarters'"
      >
        <index-r :num="completeness" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getnotice, getcourselist } from "@/api/index";
import vTopTitle from "../components/tabBur";
import fbpl from "../components/fbpl";
import dtjl from "../components/dtjl";
import indexR from "../components/indexR";
export default {
  props: {},
  data() {
    return {
      noticeList: [],
      courseList: [],
      listLoading: false,
      completeness: 0,
    };
  },
  computed: {
    roles() {
      return this.$store.state.roles;
    },
  },
  filters: {
    addtime(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  created() {
    this.getnotice();
  },
  mounted() {},
  watch: {},
  methods: {
    getnotice() {
      this.listLoading = true;
      let obj = {
        type: "notice",
        limit: 3,
        page: this.page,
      };
      getnotice(obj).then((response) => {
        
        this.noticeList = response.result;
        if (this.roles !== "notEnrolled") {
          getcourselist().then((response) => {
            this.courseList = [];
            for (let index = 0; index < response.course.length; index++) {
              // if (index < 3) {
                this.courseList.push(response.course[index]);
              // }
            }
            this.completeness = response.completeness;
            this.listLoading = false;
          });
        } else {
          this.listLoading = false;
        }
      });
    },
  },
  components: { vTopTitle, fbpl, dtjl, indexR },
};
</script>

<style>
</style>

<style scoped>
.lke-bg {
  display: flex;
}
.lke-l {
  flex: 1;
  margin-right: 20px;
}
.lke-r {
  width: 230px;
}
.lke-top-title {
  display: flex;
  align-items: center;
}
.lke-ti-ul {
  margin-bottom: 20px;
}
.lke-ti-ul li {
  padding: 5px 10px;
  border-bottom: 1px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lke-ti-ul li p {
  font-size: 13px;
  letter-spacing: 0.5px;
  color: #888888;
  cursor: pointer;
}
.lke-ti-ul li p:hover {
  color: #2890f4;
}
.lke-ti-ul-span {
  font-size: 12px;
  color: #999999;
}
.lke-ti-ul-div {
  padding: 3px 20px;
  background: #2890f4;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/index/index.vue